import { makeAutoObservable } from 'mobx';

import { ModalName } from './globalModals.enums';

class GlobalModalsStore {
  activeModal: null | ModalName = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  openFeatureRestricted() {
    this.activeModal = ModalName.FeatureRestricted;
  }

  closeModal() {
    this.activeModal = null;
  }

  get isFeatureRestrictedOpen() {
    return this.activeModal === ModalName.FeatureRestricted;
  }
}

export default GlobalModalsStore;
